export const QR_DESIGN = { width: 390, height: 704 }

export const QR_OVERLAY = { x: 155, y: 438, size: 79 }

export const qrOverlayPercentStyle = () => ({
    left: `${(QR_OVERLAY.x / QR_DESIGN.width) * 100}%`,
    top: `${(QR_OVERLAY.y / QR_DESIGN.height) * 100}%`,
    width: `${(QR_OVERLAY.size / QR_DESIGN.width) * 100}%`,
})

export const scaleQrOverlay = (naturalWidth, naturalHeight) => {
    const width = naturalWidth > 0 ? naturalWidth : QR_DESIGN.width
    const height = naturalHeight > 0 ? naturalHeight : QR_DESIGN.height

    return {
        x: Math.round(QR_OVERLAY.x * (width / QR_DESIGN.width)),
        y: Math.round(QR_OVERLAY.y * (height / QR_DESIGN.height)),
        size: Math.round(QR_OVERLAY.size * (width / QR_DESIGN.width)),
    }
}

export const loadImageSize = (src) =>
    new Promise((resolve, reject) => {
        if (!src) {
            reject(new Error('Missing image src'))
            return
        }

        const img = new Image()
        if (typeof src === 'string' && /^https?:\/\//i.test(src)) {
            img.crossOrigin = 'Anonymous'
        }
        img.onload = () =>
            resolve({
                width: img.naturalWidth,
                height: img.naturalHeight,
            })
        img.onerror = reject
        img.src = src
    })
